(function() {
    'use strict';
    angular
        .module('emarket.commons')
        .factory('Validation', ['$http', 'PATH', function($http, PATH) {
            var email = function(email) {
                var url = PATH.api + 'auth/validate/email/send';
                return $http
                    .post(url, {
                        email: email
                    })
                    .then(function(response) {
                        return response.data;
                    });
            };
            var phone = function() {};
            return {
                email: email,
                phone: phone
            };
        }]);
}());
